import { useState } from "react";
import * as yup from "yup";
import { Module } from "../../../assets/types/common";
import { StringHelper } from "../../../assets/utils/helpers";
import { Constants } from "../../../assets/utils/lib/constants";
import { LookupVIewDto } from "../../../assets/utils/lib/lookupDto";
import { DropdownOption } from "../../../assets/vfx/controls/components/dropdown/controlDropdown";
import Drawer from "../../../assets/vfx/drawer/drawer";
import Form from "../../../assets/vfx/form/form";
import { ViewProps } from "../props";
import { LookupValueService } from "./lookupValueService";
import { DrawerFormSaveResult, hasClientErrorOperationStatusCode } from "../../../assets/utils/lib";

interface LookupValueFormProps<T> {
    data?: T | undefined;
    show: boolean;
    lookupCategoryLookupValues?: DropdownOption[] | undefined;
    moduleType: Module;
    onHide: () => void;
    onSave: (values: any) => DrawerFormSaveResult;
    isLoading: boolean;
}

const validationSchema = yup.object().shape({
    name: yup.string().required("Name is required"),
    description: yup.string().optional(),
});

export function LookupValueForm<T extends ViewProps.ValueTypeDto>( props: LookupValueFormProps<T> ) {
    let title: string = "Edit Lookup Category";
    const typeDto: LookupVIewDto | undefined = props?.data as LookupVIewDto;
    const [typeId, setTypeId] = useState<string | undefined>(typeDto?.typeId);
    

    if ( StringHelper.whenNullOrEmpty(typeDto?.id, Constants.emptyGuid) ===     Constants.emptyGuid ) {
        title = "New Lookup Category";
    }

    const service: LookupValueService<T> = new LookupValueService<T>(
        props.moduleType
    );

    const onSubmit = (data: any) => {
        return Promise.resolve(props.onSave(data)).then((result) => {
        if (hasClientErrorOperationStatusCode(result)) {
            return;
        }

        props.onHide();
    });
    };

    const grouplookupsquery = service.getLookupGroupAsLookupQuery(typeId ?? typeDto?.typeId);

    return (
        <Drawer.Form
            className="w-30"
            show={props.show}
            backdrop={true}
            placement="end"
            scroll={true}
            onHide={() => props.onHide()}
            title={title}
            initialValues={typeDto ?? {}}
            validationSchema={validationSchema}
            on_Submit={onSubmit}
            enableReinitialize
        >
            <Form.Text
                name="name"
                placeholder="Enter text"
                label="Name"
                isLoading={props.isLoading}
            />
            <Form.TextArea
                name="description"
                rows={3}
                label="Description"
                isLoading={props.isLoading}
            />
            <Form.Dropdown
                name={"typeId"}
                label={"Category"}
                isLoading={props.isLoading}
                blankOption={{ key: Constants.emptyGuid, display: '--Select Category--', value: Constants.emptyGuid }}
                options={props?.lookupCategoryLookupValues}
                onChange={(e: any) => {
                    setTypeId(e.target.value);
                }}
            />
            <Form.Dropdown name={"groupId"} label={"Group"} isLoading={props.isLoading || grouplookupsquery.isLoading}
                blankOption={{ key: Constants.emptyGuid, display: '--Select Group--', value: Constants.emptyGuid }}
                options={grouplookupsquery?.data ?? []}
            />
        </Drawer.Form>
    );
}
